import { render, staticRenderFns } from "./PassengerInformation.vue?vue&type=template&id=1f6bec4e&scoped=true"
import script from "./PassengerInformation.vue?vue&type=script&lang=js"
export * from "./PassengerInformation.vue?vue&type=script&lang=js"
import style0 from "./PassengerInformation.vue?vue&type=style&index=0&id=1f6bec4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6bec4e",
  null
  
)

export default component.exports